import styled from 'styled-components'
import pxToRem from '../utils/pxToRem'

export const MainContainer = styled.div`
  max-width: ${pxToRem(1198)};
  width: 100%;
  margin: auto;
  padding: ${pxToRem(10)} 0;
`
